import { GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { ProceduresState } from '@/store/procedures/types';

export const getters: GetterTree<ProceduresState, RootState> = {};
